
export const newVariable: VariableDetail = {
    name: '',
    version: '1.0',
    description: '',
    status: '' as VariableStatusType, 
    type: 'gauge',
    scope: '101',
    persist: 0,
    boundaries: [],
    unit: '',
    minimum_cdc_version: '',
    current_status_name: '',
    rfms_name: '',
    value_names: [{hexCode:"",name:""}],
    chain: [{type:"input"}] as ChainDataType, 
    modifiedBy: '',
    should_remove_redundant_samples: false,
    max_samples: undefined,
    sample_interval_ms: undefined
  };


export enum ChainItemTypeEnum {
  AbsoluteCount = "absolute_count",
  Accumulating = "accumulating",
  AccumulatingSelf = "accumulating_self",
  AccumulatingTime = "accumulating_time",
  Acking = "acking",
  Age = "age",
  Comparator = "comparator",
  Differential = "differential",
  Dyadic = "dyadic",
  Filter = "filter",
  Index = "index",
  Input = "input",
  LowPass = "lowpass",
  Map = "map",
  Not = "not",
  Polynomial = "polynomial",
  Signals = "Signals",
  TrailerIdentification = "trailer_identification",
  TypeCast = "type_cast",
  WindowedAverage = "windowed_average",
  Work = "work"
}
  